module.exports = __webpack_public_path__ + "img/logo.9db6fc47.png";